<div class="flex-container max-width howto">
	<div class="flex-container direction-column max-width help-content">
		<div class="flex-container direction-row align-items item">
			<span class="secondary">1.</span>
			<a href="https://www.youtube.com/playlist?list=PL-UarQEmdBeemN8wXw9_zndzj2HdeVOlc" target="_blank">Видео уроки на Укр/Рус</a>
		</div>
		<div class="flex-container direction-row align-items item">
			<span class="secondary">2.</span>
			<a href="https://www.youtube.com/playlist?list=PL-UarQEmdBeceVP_l-QqfTS1S7PGDDE58" target="_blank">Video guides in English</a>
		</div>
	</div>
</div>
